import { useChannel } from '@/api/endpoints/channels'
import { TiktokUploadModal } from '@/features/platforms/tiktok/upload'
import { YoutubeUploadModal } from '@/features/platforms/youtube/upload'

export interface UploadModalProps {
  open: boolean
  onClose: () => void
  /** The video about to be published. Title/description/tags default from its metadata. */
  videoId: string
  language: string
  channel: string
  defaultTitle?: string
  defaultDescription?: string
  defaultTags?: ReadonlyArray<string>
  onStarted?: (jobKey: string) => void
}

/**
 * Platform-aware upload dispatcher.
 *
 * Resolves the channel via ``useChannel`` (cached) and routes to the
 * platform-specific modal — ``YoutubeUploadModal`` (full form with
 * scheduling, categories, etc.) or ``TiktokUploadModal`` (caption +
 * inbox/direct mode + privacy when direct).
 *
 * Callers don't pass ``platform``: the channel slug is the only key
 * needed since each channel knows which platform it lives on.
 */
export function UploadModal(props: UploadModalProps) {
  const channelQuery = useChannel(props.channel)
  // Default to ``youtube`` while the channel record loads so the modal
  // renders something familiar instead of flashing the TikTok placeholder.
  const platform = channelQuery.data?.platform ?? 'youtube'

  if (platform === 'tiktok') {
    return <TiktokUploadModal {...props} />
  }
  return <YoutubeUploadModal {...props} />
}
